var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShuru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2639_20544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.64673 1.84796C9.33366 1.84179 9.01865 1.83862 8.70161 1.83862C6.90426 1.83862 5.1467 1.93388 3.46446 2.11057C2.46866 2.21516 1.65978 2.96317 1.51668 3.95416C1.33575 5.20716 1.24179 6.51588 1.24179 7.84593C1.24179 9.1306 1.33572 10.3786 1.50471 11.5926C1.65239 12.6535 2.54874 13.4336 3.61524 13.5328C3.70117 13.5408 3.78726 13.5489 3.87353 13.5569C4.14232 13.5819 4.41278 13.6072 4.68479 13.6318V16.7583C6.36244 16.0048 7.32227 15.293 8.57419 13.853C8.61664 13.8531 8.65911 13.8532 8.70161 13.8532C10.477 13.8532 12.1961 13.7459 13.8636 13.5766C14.8957 13.4716 15.7313 12.6877 15.8763 11.6605C16.0293 10.577 16.1334 9.46496 16.1565 8.32487",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6903 3.64392C12.524 2.8102 12.6807 1.24182 13.0284 1.24182C13.376 1.24182 13.5328 2.8102 14.3665 3.64392C15.2002 4.47764 16.7582 4.56594 16.7582 4.97173C16.7582 5.37752 15.2002 5.46582 14.3665 6.29954C13.5328 7.13327 13.376 8.70164 13.0284 8.70164C12.6807 8.70164 12.524 7.13327 11.6903 6.29954C10.8566 5.46582 9.29854 5.37752 9.29854 4.97173C9.29854 4.56594 10.8566 4.47764 11.6903 3.64392Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2639_20544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuru);
export default __webpack_public_path__ + "static/media/shuru.33494daa1b6f9a7813d7d057732a79b0.svg";
export { ForwardRef as ReactComponent };